exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sectionhdr{margin-bottom:2rem;font-size:12px;font-weight:600}.formgroup{padding:24px 0;background-color:#fff;min-height:200px}.toolbox{background-color:#fafafa;min-height:350px}ul.timeline{list-style-type:none;position:relative}ul.timeline:before{content:\" \";background:#d4d9df;display:inline-block;position:absolute;left:29px;width:2px;height:100%;z-index:400}ul.timeline>li{margin:20px 0;padding-left:20px}ul.timeline>li:before{content:\" \";background:#fff;display:inline-block;position:absolute;border-radius:50%;border:3px solid;border-color:inherit;left:20px;width:20px;height:20px;z-index:400}.state{white-space:nowrap}.first-inverted{background-color:#606b75;color:#fff;font-weight:700}thead.thead-dark{border:1px solid #606b75}.actionbutton{min-width:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-986b7376","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/EditAproposalItem.vue
// module id = 667
// module chunks = 0